import { render, staticRenderFns } from "./WrongBrowser.vue?vue&type=template&id=1e9e7a55&scoped=true"
import script from "./WrongBrowser.vue?vue&type=script&lang=js"
export * from "./WrongBrowser.vue?vue&type=script&lang=js"
import style0 from "./WrongBrowser.scss?vue&type=style&index=0&id=1e9e7a55&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9e7a55",
  null
  
)

export default component.exports